import { Component, OnInit } from '@angular/core';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-lineup-premiere',
  templateUrl: './lineup-premiere.component.html',
  styleUrls: ['./lineup-premiere.component.css']
})
export class LineupPremiereComponent implements OnInit {

  premierelist: any;
  cinejoySchedule: any;
  datePipeString: string;
  isDisabled = true;
  archive = false

  constructor(
    private spotlightService: SpotlightService,
    public router: Router
  ) { }

  ngOnInit(): void {

    if (this.router.url.includes('archive')) {
      this.archive = true
      this.spotlightService.getArchiveData().subscribe(data => {
        this.premierelist = data.cinejoyArchiveSpotlights;
        this.spotlightService.setIsMotionGraphicsCompleted(false);
        this.premierelist.sort((x: any, y: any) => +new Date(x.cinejoySpotlightsSchedule[0].scheduleTimeText) - +new Date(y.cinejoySpotlightsSchedule[0].scheduleTimeText));

      });
    }
    else {
      this.archive = false
      this.spotlightService.getData().subscribe(data => {
        this.premierelist = data;
        this.spotlightService.setIsMotionGraphicsCompleted(false);
        this.premierelist.sort((x: any, y: any) => +new Date(x.cinejoySpotlightsSchedule[0].scheduleTimeText) - +new Date(y.cinejoySpotlightsSchedule[0].scheduleTimeText));

      });
    }
  }

}
